import {Link} from 'react-router'

export const NavBackHeader = ({actionText, link, children}) => (
  <header>
    <div className="back-action">
      <Link className="size-m" to={link}>← {actionText}</Link>
      {children}
    </div>
  </header>
)
